module.exports = __webpack_public_path__ + "media/images/icons/collapse-right-6ccff034cf4928eca0beeb04245458c5.svg";